import { CirclePacking } from '../../models/circlePackingModel';
import { FONT_SIZE_RANGE } from '../constants';
import { getSiblings } from './helpers/siblings';
import { wrapText } from './helpers/wrapText';

import * as d3 from 'd3';

export const text: (circle: any, formatLabel: (label: string) => string) => void = (circle, formatLabel) => {
  const siblings = getSiblings(circle);

  if (siblings) {
    const scaledFont = scaleToValue(siblings, FONT_SIZE_RANGE, circle.doc_count);

    const wrappedText = wrapText(formatLabel(circle.label), circle.r * 2, true, scaledFont);
    circle.wrappedText = wrappedText;
  }
};
const scaleToValue: (siblings: Array<CirclePacking>, rangeFontSize: Array<number>, value: number) => number = (
  siblings,
  rangeFontSize,
  value
) => {
  const dataRange = d3.extent(siblings, (d) => d.doc_count);
  const scaleFont = d3.scaleLinear().domain(dataRange).range(rangeFontSize);
  return scaleFont(value);
};
